import type { FC, ReactNode } from 'react'

import { BookOpenCheck, HeartHandshake, Sprout } from 'lucide-react'

import { Container } from '@/components/generals/container'

const ITEMS = [
    {
        icon: BookOpenCheck,
        title: 'Evidence-aware',
        text: 'We lean on research and say so plainly when the science is thin. No hype, no miracle cures.'
    },
    {
        icon: Sprout,
        title: 'Whole-person',
        text: 'Body, mind, and daily life are connected. We write for all of it, not one narrow slice.'
    },
    {
        icon: HeartHandshake,
        title: 'Practical, not preachy',
        text: 'Small, doable changes that fit a real schedule beat unsustainable overhauls every time.'
    }
]

export const HomePrinciples: FC = (): ReactNode => {
    return (
        <section className='border-y border-border bg-secondary/40'>
            <Container className='py-14'>
                <div className='grid gap-10 sm:grid-cols-3'>
                    {ITEMS.map((item) => (
                        <div key={item.title} className='flex flex-col gap-3'>
                            <span className='flex size-10 items-center justify-center rounded-full bg-primary/10 text-primary'>
                                <item.icon className='size-5' />
                            </span>
                            <h3 className='font-heading text-lg font-semibold tracking-tight text-foreground'>
                                {item.title}
                            </h3>
                            <p className='text-sm leading-relaxed text-muted-foreground'>
                                {item.text}
                            </p>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    )
}
